export default __webpack_public_path__ + "static/media/V02.f006f635.png";